import React from 'react';

interface typeData {
  _id: string;
  name: string;
}

interface typeProps {
  title: string;
  data: typeData[];
  value: string;
  setSelected: Function;
  required?: boolean;
  className?: string;
}

export default function Select({ title, data, value, setSelected, required,className }: typeProps) {

  return (
    <div className="field">
      <label htmlFor={title}>{title}:</label>
      <select
      className={className}
        name={title}
        value={value}
        onChange={({ target }) => {
          setSelected(target.value);
        }}
        required={required}

      >
        <option value="">
          {data.length > 0 ? '-- Selecione --' : 'Carregando ...'}
        </option>
        {data.sort((a: typeData, b: typeData) => a.name.localeCompare(b.name))
          .map(({ _id, name }: typeData) => {
            return (
              <option key={_id} value={_id}>
                {name}
              </option>
            );
          })}
      </select>
    </div>
  );
}
